import { httpPost } from "shared/api/apiHandler";
import urls from "shared/api/spaceStone/urls";
import {
    RegisterAgent,
    RegisterCorporateLandlord,
    RegisterPrivateLandlord,
    RegisterTenant,
    RegisterInternalUser,
} from "shared/models/spaceStone/signUp";

export const registerAgent = async (data: RegisterAgent): Promise<string> => {
    const result = await httpPost<string, RegisterAgent>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.AGENT.REGISTER_AGENT,
        data
    );
    return result.data;
};

export const registerCorporateLandlord = async (data: RegisterCorporateLandlord): Promise<string> => {
    const result = await httpPost<string, RegisterCorporateLandlord>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.LANDLORD.REGISTER_CORPORATE_LL,
        data
    );
    return result.data;
};

export const registerTenant = async (data: RegisterTenant): Promise<string> => {
    const result = await httpPost<string, RegisterTenant>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.TENANT.REGISTER_TENANT,
        data
    );
    return result.data;
};

export const registerPrivateLandlord = async (data: RegisterPrivateLandlord): Promise<string> => {
    const result = await httpPost<string, RegisterTenant>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.LANDLORD.REGISTER_PRIVATE_LL,
        data
    );
    return result.data;
};

export const registerInternalUser = async (data: RegisterInternalUser): Promise<string> => {
    const result = await httpPost<string, RegisterInternalUser>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.ADMINISTRATION.ROOT,
        data
    );
    return result.data;
};
